import { CONTACT } from "../../data/content";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[#16181a]/15 bg-[#f0ead9]">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-14">
      <div>
        <p className="font-display text-xl text-[#16181a]">
          Gianni Ragone<span className="text-[#c0442b]">.</span>
        </p>
        <p className="mt-1 font-body text-xs uppercase tracking-widest text-[#6e6a64]">
          Direttore Creativo
        </p>
      </div>

      <div className="flex flex-wrap gap-6">
        {CONTACT.socials.map((s) => (
          <a
            key={s.label}
            data-testid={`footer-social-${s.label.toLowerCase()}`}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className="link-underline font-body text-xs uppercase tracking-widest text-[#2a2b2d]"
          >
            {s.label}
          </a>
        ))}
      </div>

      <p className="font-body text-xs text-[#6e6a64]">
        © {new Date().getFullYear()} Gianni Ragone — P.IVA IT08489230725
      </p>
    </div>
  </footer>
);
